import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-channel-command",
  "use": "icon-soc-mall-channel-command-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-channel-command\">\r\n<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n  <rect x=\"140\" y=\"160\" width=\"280\" height=\"200\" rx=\"36\" />\r\n  <rect x=\"604\" y=\"160\" width=\"280\" height=\"200\" rx=\"36\" />\r\n  <rect x=\"140\" y=\"664\" width=\"280\" height=\"200\" rx=\"36\" />\r\n  <rect x=\"604\" y=\"664\" width=\"280\" height=\"200\" rx=\"36\" />\r\n  <path d=\"M280 360v120h464V360M280 664V544h464v120\" />\r\n</g>\r\n<circle cx=\"280\" cy=\"260\" r=\"28\" fill=\"currentColor\" />\r\n<circle cx=\"744\" cy=\"260\" r=\"28\" fill=\"currentColor\" />\r\n<circle cx=\"280\" cy=\"764\" r=\"28\" fill=\"currentColor\" />\r\n<circle cx=\"744\" cy=\"764\" r=\"28\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-channel-command.svg
// module id = 1vTX
// module chunks = 492